import Icon from "@ant-design/icons";
import type { GetProps } from "antd";

// Вилица и нож — рисунката е по „utensils" от Lucide (ISC лиценз), с дебелина
// като на antd Outlined иконите. antd няма такава иконка.
const ForkKnifeSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
    <path d="M7 2v20" />
    <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
  </svg>
);

/**
 * Знакът на обедното меню — навсякъде, където иконката значи „обедно":
 * етикетът „Обедно", бутонът „Обедно меню" в горната лента, празният списък.
 * (Часовникът до часовете на менюто е време, не „обедно" — остава.)
 */
export const ForkKnifeIcon = (props: Partial<GetProps<typeof Icon>>) => (
  <Icon component={ForkKnifeSvg} {...props} />
);
